/* eslint-disable hydrogen/prefer-image-component */
import {ReactElement, useMemo} from 'react';
import {Link} from '@shopify/hydrogen';

import {theWhiskyListLogoCenterPNG} from '../assets/img';
import {useAuthService} from '../contexts/AuthServiceProvider.client';
import SignupStep1Form from './forms/SignupStep1Form.client';

export default function SignupStepContainer(): ReactElement {
  const {authUser} = useAuthService();
  const containerTitle = useMemo(() => {
    if (authUser) {
      return <>Welcome, {authUser ? authUser.first_name : ''}</>;
    }
    return (
      <>
        Join TWL&apos;s community of <br /> Whisky Lovers
      </>
    );
  }, [authUser]);

  return (
    <div className="signup__area show-step">
      <div className="signup__form-outer">
        <Link to="/" className="signup__logo">
          <img src={theWhiskyListLogoCenterPNG} alt="The Whisky List" />
        </Link>
        <h4 className="title-2 align-center">{containerTitle}</h4>
        <SignupStep1Form />
      </div>
    </div>
  );
}
/* eslint-enable hydrogen/prefer-image-component */
